class SearchDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#search-drawer-overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderSearchIconAccessibility();
    }

    setHeaderSearchIconAccessibility() {
        const searchLink = document.querySelector('#header-search-icon');
        if (!searchLink) return;

        searchLink.setAttribute('role', 'button');
        searchLink.setAttribute('aria-haspopup', 'dialog');
        searchLink.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(searchLink);
        });
        searchLink.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(searchLink);
            }
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add('animate', 'active');
        });

        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn= document.getElementById('search-drawer');
                const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true }
        );

        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('search-drawer', SearchDrawer);